/* @flow */
import Format from './format'
import { parseISO, parse, format, isValid } from 'date-fns'
import { DateInput as DateInputNative } from './input'

const checkInput = (type: string): boolean => {
  const input: HTMLInputElement = document.createElement('input')
  input.setAttribute('type', type)
  return input.type == type
}
const hasDateInput: boolean = checkInput('date')

class DateInputFake extends Format {
  static defaultProps = {
    ...Format.defaultProps,
    rootType: 'fake-date',
    type: 'tel',
    options: {
      delimiter: '.',
      blocks: [2, 2, 4],
      numeric: true
    }
  }

  normalizeValue(value: string): string {
    const test = /^([\d]{1,2})[.|/]([\d]{1,2})[.|/]([\d]{4})$/.test(value)
    if (test) {
      const date: Date = parse(value, 'dd.MM.yyyy', new Date())
      if (isValid(date)) {
        return format(date, 'yyyy-MM-dd')
      }
    }
    return value
  }

  formatValue(value: ?string): string {
    if (typeof value == 'string') {
      const test = /^([\d]{4})-([\d]{1,2})-([\d]{1,2})$/.test(value)
      if (test) {
        const date: Date = parseISO(value)
        if (isValid(date)) {
          return format(date, 'dd.MM.yyyy')
        }
      }
    }
    return value || ''
  }
}

export { DateInputFake, DateInputNative }
export default hasDateInput ? DateInputNative : DateInputFake
